import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['accordionContainer', 'accordion', 'show', 'hide']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    if (this.hasAccordionTarget) {
      if (this.accordionTarget.clientHeight > this.accordionTarget.dataset.height) {
        this.showTarget.style.display = 'flex'
        this.accordionTarget.classList.add(`${this.className}::hidden`)
      } else {
        this.showTarget.style.display = 'none'
        this.accordionTarget.classList.remove(`${this.className}::hidden`)
      }
    }
  }

  toggle () {
    if (this.element.classList.contains(`${this.className}::accordion-close`)) {
      this.open()
    } else {
      this.close()
    }
  }

  open () {
    this.element.classList.remove(`${this.className}::accordion-close`)
    this.element.classList.add(`${this.className}::accordion-open`)
  }

  close () {
    this.element.classList.remove(`${this.className}::accordion-open`)
    this.element.classList.add(`${this.className}::accordion-close`)
  }

  show (e) {
    this.accordionTarget.classList.remove(`${this.className}::hidden`)
    e.target.style.display = 'none'
  }
}
